const light = '#f4f4f4'
const primary = '#C34129'
const secondary = '#E2DBC9'
const warning = '#EFB758'
const info = '#c77777'

const colors = {
  light,
  primary,
  secondary,
  warning,
  info
}
export default colors
